import { BaseSanitizer } from './BaseSanitizer';
export class CookieSanitizer extends BaseSanitizer {
    constructor(context, enabled = true) {
        super(context, 'COOKIE', 'cookies', enabled);
    }
    detectMatches(text) {
        const matches = [];
        const cookieHeaderMatches = this.detectCookieHeaders(text);
        const trackingCookieMatches = this.detectTrackingCookies(text);
        const adIdMatches = this.detectAdvertisingIds(text);
        matches.push(...cookieHeaderMatches, ...trackingCookieMatches, ...adIdMatches);
        return this.removeOverlappingMatches(matches);
    }
    detectCookieHeaders(text) {
        const matches = [];
        const cookiePattern = /[a-zA-Z_][a-zA-Z0-9_]*=[a-zA-Z0-9+/=%._-]{20,}/g;
        let match;
        while ((match = cookiePattern.exec(text)) !== null) {
            const cookie = match[0];
            if (this.looksLikeCookie(cookie)) {
                matches.push({
                    originalText: cookie,
                    tag: '',
                    startIndex: match.index,
                    endIndex: match.index + cookie.length
                });
            }
        }
        return matches;
    }
    detectTrackingCookies(text) {
        const matches = [];
        const trackingPatterns = [
            /(_ga|_gid|_gat|_gcl_au|_fbp|_fbc|fr|__utma|__utmb|__utmc|__utmz|__utmt|_ga_[A-Z0-9]+)=([A-Z0-9]+\.){2,}[A-Z0-9]+/gi,
            /(session_id|sessionid|sid|sessid|phpsessid|jsessionid|aspsessionid)=[a-zA-Z0-9]{20,}/gi,
            /(user_token|user_token|auth_token|access_token|bearer_token)=[a-zA-Z0-9_\-\.]{20,}/gi
        ];
        for (const pattern of trackingPatterns) {
            let match;
            while ((match = pattern.exec(text)) !== null) {
                matches.push({
                    originalText: match[0],
                    tag: '',
                    startIndex: match.index,
                    endIndex: match.index + match[0].length
                });
            }
        }
        return matches;
    }
    detectAdvertisingIds(text) {
        const matches = [];
        const adIdPatterns = [
            /GAID[:\s]*[a-f0-9]{32}/gi, // Google Advertising ID
            /AID[:\s]*[a-f0-9]{32}/gi, // Android Advertising ID
            /google_aid[:\s]*[a-f0-9]{32}/gi,
            /advertising_id[:\s]*[a-f0-9]{32}/gi,
            /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/g // UUID format (often used for ad tracking)
        ];
        for (const pattern of adIdPatterns) {
            let match;
            while ((match = pattern.exec(text)) !== null) {
                const adId = match[0];
                if (this.looksLikeAdIdContext(text, match.index)) {
                    matches.push({
                        originalText: adId,
                        tag: '',
                        startIndex: match.index,
                        endIndex: match.index + adId.length
                    });
                }
            }
        }
        return matches;
    }
    looksLikeCookie(cookie) {
        const commonCookieNames = [
            'session', 'sid', 'sess', 'token', 'auth', 'user', 'login', 'track',
            'id', 'uid', 'guid', 'visitor', 'visitor_id', 'analytics', 'ga', 'fb', '_ga'
        ];
        const [name] = cookie.split('=');
        const lowerName = name.toLowerCase();
        return commonCookieNames.some(cn => lowerName.includes(cn)) ||
            cookie.length > 30;
    }
    looksLikeAdIdContext(text, index) {
        const before = text.substring(Math.max(0, index - 20), index).toLowerCase();
        const after = text.substring(index, Math.min(text.length, index + 10)).toLowerCase();
        const keywords = ['advertising', 'ad', 'tracking', 'gaid', 'aid', 'idfa', 'device', 'mobile'];
        return keywords.some(keyword => before.includes(keyword) || after.includes(keyword));
    }
}
